/**
 * Возвращает имя микрофронта из имени виджета
 * @param widget
 */
export const getMicrofrontNameByWidget = (widget) => { var _a; return (_a = widget.split('/').shift()) !== null && _a !== void 0 ? _a : ''; };
